import PurchaseOrderDetails from "pages/Procurement/PurchaseOrder/View/PurchaseOrderDetails";

const TagPurchaseOrderDetails = () => {
  return <PurchaseOrderDetails />;
};

export default TagPurchaseOrderDetails;
